<template>
  <div>
    <div class="title_text">
      <div>
        <Icon type="ios-bookmark" size="18" color="#0466dd" />
        <span class="title_text2">借支功能配置</span>
      </div>
    </div>
    <div class="jiezhi_peizhi_div">
      <div class="jiezhi_count_tishi">
        提示：2025/10/31起，财务规定每月最多借支2次，每月最多2000元，有特殊情况请联系财务或联系运营总沟通处理
      </div>
      <div class="setting_input">
        <div class="jiezhi_peizhi_title">每月可借支最大金额：</div>
        <div>
          <InputNumber size="small" :min="0" v-model="setting_data.money" @on-change="focus_change" />
          <span style="margin-left: 5px">元</span>
        </div>

      </div>
      <div class="setting_input">
        <div class="jiezhi_peizhi_title">每月可借支次数：</div>
        <div>
          <InputNumber size="small" :min="0" v-model="setting_data.month_count" @on-change="focus_change" />
          <span style="margin-left: 5px">次</span>
        </div>

      </div>

      <div class="setting_input">
        <div class="jiezhi_peizhi_title">新借支与核销规则：</div>
        <div>
          <Select size="small" v-model="setting_data.after_verification" style="width: 200px" @on-change="focus_change">
            <Option :value="0">无需核销仍可新借支</Option>
            <Option :value="1">需核销后才可新借支</Option>
          </Select>
        </div>
      </div>

      <div class="setting_input">
        <div class="jiezhi_peizhi_title">借支短信通知</div>
        <div>
          <Select size="small" v-model="setting_data.switch_sms_notify" style="width: 200px"
            @on-change="sms_notify_change">
            <Option :value="0">关闭</Option>
            <Option :value="1">打开</Option>
          </Select>
        </div>
      </div>
    </div>
    <div class="title_text">
      <div>
        <Icon type="ios-bookmark" size="18" color="#0466dd" />

        <span class="title_text2">员工借支数据</span>
      </div>

      <div class="query_box"></div>
      
    </div>

    <div class="data_div">
         <div class="jiezhi_count_tishi2">
        重要通知：禁止违规借支！工资发放需走发薪流程; 严禁以“借支”形式拆分发放或冲抵员工工资！特别是离职前用借支替代发薪！
      </div>
      <div class="card_main">
        <Spin fix v-if="table_loading"></Spin>

        <div class="count_card" @click="click_count('待审核', 0)">
          <div>
            <CountUp :end="daishen_count" :duration="2" ref="count" v-font="18" />
          </div>

          <div class="count_title2">待审核</div>
        </div>

        <div class="count_card" @click="click_count('审核通过', 1)">
          <div>
            <CountUp :end="tongguo_count" :duration="2" ref="count" v-font="18" />
          </div>

          <div class="count_title2">审核通过</div>
        </div>

        <div class="count_card" @click="click_count('审核不通过', 2)">
          <div>
            <CountUp :end="butongguo_count" :duration="2" ref="count" v-font="18" />
          </div>

          <div class="count_title2">审核不通过</div>
        </div>

        <div class="count_card2" @click="click_unwritten()">
          <div>
            <CountUp :end="unwritten_count" :duration="2" ref="count" v-font="18" />
          </div>
          <div class="count_title2">手动核销借支</div>
        </div>

        <!-- <div class="count_card" @click="click_peizhi">
          <div class="count_card_1">
            <span class="iconfont iconpeizhi icon2"></span>
          </div>
          <div class="count_title2">借支配置</div>
        </div> -->
      </div>
    </div>

    <relieve_data ref="relieve_data"></relieve_data>

    <Drawer title="借支配置" :closable="true" v-model="setting_show" width="400">
      <div class="setting_input">
        <div>每月可借支最大金额：</div>
        <div>
          <InputNumber :min="0" v-model="setting_data.money" />
          <span style="margin-left: 5px">元</span>
        </div>
      </div>

      <div class="setting_input">
        <div>新借支与核销规则：</div>
        <div>
          <Select v-model="setting_data.after_verification" style="width: 160px">
            <Option :value="0">无需核销仍可新借支</Option>
            <Option :value="1">需核销后才可新借支</Option>
          </Select>
        </div>
      </div>
      <div class="confirm_div">
        <Button type="primary" @click="update_jiezhi_setting_info">确认更新</Button>
      </div>
    </Drawer>

    <Drawer :title="drawer_title" :closable="true" v-model="drawer_show" width="95">
      <div class="tishi" v-if="drawer_index == 0">审核须知：非本人领取，必须核对委托书是否有员工手写签名，电子版不可以，不符请驳回让员工重新提交，请各位小伙伴把好关！</div>
      <div class="table_card_scroll">
        <Spin size="large" fix v-if="table_loading">正在加载中</Spin>

        <div class="download_box">
          <div class="" v-if="drawer_index == 0">
            <!-- 提示：借支审核通过后，对接财务发放，请仔细核对信息，操作后不可撤销！ -->
            <div class="is_hexiao_div">
              <span>姓名搜索：</span>
              <Input size="small" v-model="search_value" placeholder="请输入姓名..." style="width: 100px" />
              <Button @click="click_search" size="small" type="primary">搜索</Button>

            </div>

          </div>

          <div v-else class="left_btn">
            <div class="is_hexiao_div">
              <span>发放状态：</span>
              <Select size="small" v-model="is_fafang" style="width: 100px; margin-right: 10px"
                @on-change="is_hexiao_change">
                <Option v-for="(item, i) in is_fafang_options" :value="item.value" :key="i">{{ item.label }}</Option>
              </Select>
            </div>
            <div class="is_hexiao_div">
              <span>核销状态：</span>
              <Select size="small" v-model="is_hexiao" style="width: 100px" @on-change="is_hexiao_change">
                <Option v-for="(item, i) in is_hexiao_options" :value="item.value" :key="i">{{ item.label }}</Option>
              </Select>
            </div>
            <div class="is_hexiao_div" style="margin-left: 10px">
              <span>姓名搜索：</span>
              <Input v-model="search_value" placeholder="请输入姓名..." style="width: 100px" size="small" />
              <Button @click="click_search" size="small" type="primary">搜索</Button>
            </div>
          </div>

          <div class="download_box_right">
            <Button v-if="drawer_index == 0" @click="click_tongguo" type="success"
              style="font-size: 12px; margin-right: 10px" size="small">
              通过
            </Button>

            <Button v-if="drawer_index == 0" @click="click_butongguo" type="error"
              style="font-size: 12px; margin-right: 10px" size="small">
              不通过
            </Button>

            <!-- <Button
    
                  v-if="drawer_index == 1"
    
                  type="success"
    
                  style="font-size: 12px; margin-right: 10px"
    
                  size="small"
    
                  @click="hexiao_confirm"
    
                >
    
                  <Icon type="ios-archive" /> 核销借支
    
                </Button> -->

            <Button @click="click_download" type="primary" style="font-size: 12px" size="small" :loading="download_loading">
              <Icon type="md-cloud-download" />下载表格
            </Button>
          </div>
        </div>

        <Table v-if="drawer_index == 0" @on-selection-change="table_selection_change" ref="table"
          :height="windowHeight - 190" size="small" :columns="columns" :data="audit_list">
          <template #cailiao="{ row }">
            <a @click="click_img_list(row)">
              <Icon type="ios-eye-outline" />查看({{ row.img_list.length }})
            </a>

            <a v-if="row.weituo_name" style="margin-left: 5px" @click="click_weituo(row)">
              <Icon type="ios-eye-outline" />委托书
            </a>
          </template>

          <template #is_self="{ row }">

            <span>{{ row.is_self == 1 ? '本人' : '非本人' }}</span>
          </template>

          <template #is_hexiao="{ row }">
            <Tag v-if="row.is_hexiao == 1" color="success"> 已核销</Tag>

            <Tag color="warning" v-if="row.is_hexiao == 0">未核销</Tag>
          </template>

          <template #del="{ row }">
            <span class="del_jiezhi" @click="del_jiezhi(row)">删除</span>
          </template>
        </Table>

        <Table v-if="drawer_index == 1" @on-selection-change="table_selection_change_1" ref="table"
          :height="windowHeight - 160" size="small" :columns="columns" :data="audit_list">
          <template #cailiao="{ row }">
            <a @click="click_img_list(row)">
              <Icon type="ios-eye-outline" />查看({{ row.img_list.length }})
            </a>

            <a v-if="row.weituo_name" style="margin-left: 5px" @click="click_weituo(row)">
              <Icon type="ios-eye-outline" />委托书
            </a>
          </template>
          <template #is_hexiao="{ row }">
            <Tag v-if="row.is_hexiao == 1" color="success"> 已核销</Tag>

            <Tag color="warning" v-if="row.is_hexiao == 0">未核销</Tag>
          </template>
          <template #is_self="{ row }">
            <span>{{ row.is_self == 1 ? '本人' : '非本人' }}</span>
          </template>
          <template #is_fafang="{ row }">
            <Tag v-if="row.is_fafang == 1" color="success"> 已发放</Tag>

            <Tag color="warning" v-if="row.is_fafang == 0">未发放</Tag>

            <Tag color="error" v-if="row.is_fafang == 2">发放异常</Tag>
          </template>
          <template #fafang_time="{ row }">
            <span class="">{{ row.fafang_time }} </span>
          </template>
          <template #fafang_receipt="{ row }">
            <span v-if="row.fafang_receipt" class="fafang_receipt" @click="view_fafang_receipt(row)">银行回单
            </span>
          </template>
          <template #affirm_hexiao_time="{ row }">
            <span class="">{{ row.affirm_hexiao_time }} </span>
          </template>
          <template #del="{ row }">
            <span class="del_jiezhi" @click="del_jiezhi(row)">删除 </span>
          </template>
        </Table>

        <Table v-if="drawer_index == 2" @on-selection-change="table_selection_change" ref="table"
          :height="windowHeight - 160" size="small" :columns="columns" :data="audit_list">
          <template #is_fafang="{ row }">
            <Tag v-if="row.is_fafang == 1" color="success"> 已发放</Tag>

            <Tag color="warning" v-if="row.is_fafang == 0">未发放</Tag>

            <Tag color="error" v-if="row.is_fafang == 2">发放异常</Tag>
          </template>
          <template #is_self="{ row }">
            <span>{{ row.is_self == 1 ? '本人' : '非本人' }}</span>
          </template>
          <template #cailiao="{ row }">
            <a @click="click_img_list(row)">
              <Icon type="ios-eye-outline" />查看({{ row.img_list.length }})
            </a>

            <a v-if="row.weituo_name" style="margin-left: 5px" @click="click_weituo(row)">
              <Icon type="ios-eye-outline" />委托书
            </a>
          </template>
          <template #is_hexiao="{ row }">
            <Tag v-if="row.is_hexiao == 1" color="success"> 已核销</Tag>

            <Tag color="warning" v-if="row.is_hexiao == 0">未核销</Tag>
          </template>
          <template #fafang_time="{ row }">
            <span>{{ row.fafang_time }}</span>
          </template>
          <template #fafang_receipt="{ row }">
            <span v-if="row.fafang_receipt" class="fafang_receipt" @click="view_fafang_receipt(row)">银行回单
            </span>
          </template>
          <template #del="{ row }">
            <span class="del_jiezhi" @click="del_jiezhi(row)">删除 </span>
          </template>
        </Table>
        <div class="page_1">
          <Page v-model="page" :total="total_count" @on-change="page_change" :page-size="limit" />
        </div>
      </div>
      <Modal v-model="remarks_show" title="审核备注" @on-ok="remarks_ok" width="350">
        <div v-if="audit_status == 1">
          <!-- <div class="audit_box">
            <div>预计核销日期：</div>
            <div>
              <DatePicker
                type="date"
                v-model="hexiao_date"
                placeholder="核销日期"
                style="width: 150px"
              />
            </div>
          </div> -->
          <!-- <div class="audit_box">
            <div>预计发放日期：</div>
            <div>
              <DatePicker
                type="date"
                v-model="fafang_date"
                placeholder="发放日期"
                style="width: 150px"
              />
            </div>
          </div> -->
        </div>
        <div class="audit_box2">
          <div class="audit_box2_title">审核备注：</div>
          <div>
            <Input v-model="remarks_text" placeholder="请输入备注" style="width: 300px" />
          </div>
        </div>
      </Modal>

      <Modal v-model="fafang_time_show" title="发放时间更新" width="350" :footer-hide="true">
        <DatePicker type="date" v-model="fafang_time" placeholder="Select date" style="width: 200px"
          @on-change="fafang_time_update_change" />
      </Modal>

      <Modal v-model="hexiao_time_show" title="核销时间更新" width="350" :footer-hide="true">
        <DatePicker type="date" v-model="hexiao_time" placeholder="Select date" style="width: 200px"
          @on-change="hexiao_time_update_change" />
      </Modal>
    </Drawer>

    <Drawer title="通过但未核销" :closable="true" v-model="unwritten_show" width="95">
      <Spin size="large" fix v-if="table_loading">正在加载中</Spin>
      <div style="font-size:13px;padding:5px 5px 5px 5px;background-color: #f4e7e7;margin-bottom: 5px;">
        说明：忘记核销的可以在这里自行手动核销，该功能与发薪表中【借支核销金额】一样
      </div>

      <Table ref="table" :height="windowHeight - 160" size="small" :columns="columns_unwritten"
        :data="unwritten_table_data">
        <template #cailiao="{ row }">
          <a @click="click_img_list(row)">查看({{ row.img_list.length }})</a>

          <a style="margin-left: 5px" @click="click_weituo(row)">委托书</a>
        </template>

        <template #is_hexiao="{ row }">
          <Tag v-if="row.is_hexiao == 1" color="success"> 已核销</Tag>

          <Tag color="warning" v-if="row.is_hexiao == 0">未核销</Tag>
        </template>

        <template #hexiao="{ row }">
          <span class="del_jiezhi" @click="unwritten_hexiao_confirm(row)">确认核销</span>
        </template>
      </Table>


      <div class="page_1">
        <Page v-model="page" :total="total_count" @on-change="page_change" :page-size="limit" />
      </div>


    </Drawer>

    <Modal v-model="affirm_hexiao_show" title="确认核销" :mask-closable="false" :footer-hide="true" width="500">
      <div class="upload_hexiao">
        <div>上传照片：</div>
        <Upload :action="upload_url" :on-success="success_change">
          <Button icon="ios-cloud-upload-outline">上传照片</Button>
        </Upload>
      </div>
      <div class="affirm_hexiao_btn">
        <Button type="primary" @click="click_affirm_hexiao_btn">确认核销</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";
import relieve_data from "./relieve_data.vue";

export default {
  components: { relieve_data },
  name: "jiezhi_data",

  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      table_loading: false,
      project_id: "",
      project_name: "",
      data_dict: {
        audit_list: [],
        success_list: [],
        fail_list: [],
      },
      upload_url:
        process.env.VUE_APP_HOST +
        "/data_panel/jiezhi/upload_hexiao?token=" +
        this.$cookies.get("dx_token"),
      drawer_show: false,
      drawer_title: "",
      drawer_index: 0,
      audit_list: [],
      success_list: [],
      fail_list: [],
      table_data: [],
      columns: [],
      table_selection: [],
      remarks_show: false,
      remarks_text: "",
      audit_status: 0,
      hexiao_date: new Date(),
      fafang_date: new Date(),
      fafang_time: "",
      fafang_time_show: false,
      fafang_jiezhi_id: "",

      hexiao_time_show: false,
      hexiao_jizhi_id: "",
      hexiao_time: "",

      // 通过表格选择数据
      table_1_selection: [],

      total_count: 0,
      limit: 20,
      page: 1,

      butongguo_count: 0,
      daishen_count: 0,
      tongguo_count: 0,
      unwritten_count: 0,
      affirm_hexiao_show: false,
      hexiao_file: '',

      unwritten_show: false,
      unwritten_table_data: [],
      columns_unwritten: [],

      is_hexiao: -1,
      is_hexiao_options: [
        { label: "全部", value: -1 },
        { label: "未核销", value: 0 },
        { label: "已经核销", value: 1 },
        { label: "核销异常", value: 2 },
      ],

      is_fafang: -1,
      is_fafang_options: [
        { label: "全部", value: -1 },
        { label: "未发放", value: 0 },
        { label: "已发放", value: 1 },
        { label: "发放异常", value: 2 },
      ],

      search_value: "",
      search_type: "name",

      setting_show: false,
      setting_data: {
        money: 0,
        month_count: 0,
        after_verification: 0,
      },
      download_loading:false,
    };
  },

  mounted() {
    var query = this.$router.query;
    if (query) {
      this.project_id = project_id;
      this.project_name = project_name;
      this.get_jiezhi_data();
    }
  },
  methods: {


    click_unwritten() {
      this.unwritten_show = true
      this.columns_unwritten = [
        {
          type: "index",
          width: 60,
          fixed: "left",
          resizable: true,
        },
        {
          title: "姓名",
          key: "name",
          width: 80,
          fixed: "left",
          resizable: true,
        },
        {
          title: "提交时间",
          key: "create_time",
          width: 150,
          resizable: true,
        },
        {
          title: "借支金额",
          key: "money",
          width: 100,
          resizable: true,
        },
        {
          title: "发放时间",
          key: "fafang_time",
          width: 120,
          resizable: true,
        },

        {
          title: "是否核销",
          slot: "is_hexiao",
          width: 110,
          resizable: true,
        },
        {
          title: "发放主体",
          key: "project_subject_name",
          width: 160,
        },

        {
          title: "身份证号",
          key: "idcard",
          width: 180,
          resizable: true,
        },
        {
          title: "手机号",
          key: "phone",
          width: 120,
          resizable: true,
        },
        {
          title: "入职时间",
          key: "entry_time",
          width: 130,
          resizable: true,
        },

        {
          title: "委托人",
          key: "weituo_name",
          width: 100,
          resizable: true,
        },

        {
          title: "开户行",
          key: "bank_of_deposit",
          width: 120,
          resizable: true,
        },

        {
          title: "银行卡号",
          key: "bank_card_number",
          width: 180,
          resizable: true,
        },
        {
          title: "借支原因",
          key: "cause",
          width: 120,
          resizable: true,
        },
        {
          title: "证明材料",
          slot: "cailiao",
          width: 150,
          resizable: true,
        },
        {
          title: "审核备注",
          key: "audit_remarks",
          width: 120,
          resizable: true,
        },



        {
          title: "发放备注",
          key: "fafang_remarks",
          width: 120,
          resizable: true,
        },


        {
          title: "核销",
          slot: "hexiao",
          width: 100,
          fixed: 'right',

          resizable: true,
        },
        //
      ];
    },

    success_change(e) {
      console.log(e);
      this.hexiao_file = e.data.img_object_name;
    },

    unwritten_hexiao_confirm(item) {
      this.affirm_hexiao_show = true
      this.hexiao_item = item
    },

    click_affirm_hexiao_btn() {
      var that = this;

      var obj = {
        jiezhi_id: this.hexiao_item.jiezhi_id,
        object_name: this.hexiao_file,
        resume_id: this.hexiao_item.resume_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/data_panel/jiezhi/affirm_hexiao",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.affirm_hexiao_show = false;
            that.get_unwritten_count();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },



    get_unwritten_count() {
      console.log(1111)
      var that = this;
      var obj = {
        project_id: this.project_id
      }
      this.table_loading = true
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/jiezhi/jiezhi_unwritten",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.unwritten_count = res.data.unwritten_count
            that.unwritten_table_data = res.data.data_list
            that.table_loading = false
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
            that.table_loading = false
          }
        })
        .catch((res) => {

          console.log(res, "请求出错");
        });
    },


    click_peizhi() {
      this.setting_show = true;
      this.get_jiezhi_setting_info();
    },

    click_search() {
      this.page = 1;
      this.get_jiezhi_data();
    },

    click_weituo(row) {
      this.$ImagePreview.show({
        previewList: [row.weituo_url],
      });
    },
    page_change(e) {
      this.page = e;
      this.get_jiezhi_data();
    },
    // hexiao
    hexiao_confirm() {
      if (this.table_1_selection.length == 0) {
        this.$Message.error("请选择至少一位");
        return;
      }
      var that = this;
      this.$Modal.confirm({
        title: "提示",
        content:
          "<p>当前选择的人员借支是否已经核销？请检查后继续，如果已核销，请点确定！</p>",
        onOk: () => {
          that.hexiao_confirm_request();
        },
        onCancel: () => { },
      });
    },

    hexiao_confirm_request() {
      var that = this;
      var data_list = [];
      for (var i = 0; i < this.table_1_selection.length; i++) {
        var _item = {
          jiezhi_id: this.table_1_selection[i]["jiezhi_id"],
          resume_id: this.table_1_selection[i]["resume_id"],
        };
        data_list.push(_item);
      }

      var obj = {
        jiezhi_data: data_list,
      };
      this.table_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/data_panel/jiezhi/affirm_hexiao_batch",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.get_jiezhi_data();
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },

    click_img_list(row) {
      var url_list = row.img_list;
      this.$ImagePreview.show({
        previewList: url_list,
      });
    },

    table_selection_change_1(e) {
      this.table_1_selection = e;
    },

    view_fafang_receipt(row) {
      this.$ImagePreview.show({
        previewList: [row.fafang_receipt],
      });
    },

    remarks_ok() {
      var id_list = [];
      for (let i = 0; i < this.table_selection.length; i++) {
        var id = this.table_selection[i]["id"];
        id_list.push(id);
      }

      var that = this;

      var obj = {
        id_list: id_list,
        status: this.audit_status,
        remarks: this.remarks_text,
        project_id: this.project_id,
        hexiao_time: this.hexiao_date.getTime() / 1000,
        // fafang_time: this.fafang_date.getTime() / 1000,
      };
      this.table_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/jiezhi/jiezhi_audit",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.get_jiezhi_data();
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },

    //点击通过
    click_tongguo() {
      if (this.table_selection.length == 0) {
        this.$Message.error("请先选择至少一条");
        return;
      }
      var that = this;

      this.$Modal.confirm({
        title: "操作提示",
        content:
          "<p>你正在通过借支审核，请仔细核对金额等信息，通过后会提交到财务进行发放，操作后不可撤销，是否继续？</p>",
        onOk: () => {
          that.remarks_show = true;
          that.remarks_text = "通过";
          that.audit_status = 1;
        },
        onCancel: () => {
          that.$Message.info("已取消");
        },
      });
    },

    //点击不通过
    click_butongguo() {
      if (this.table_selection.length == 0) {
        this.$Message.error("请先选择至少一条");
        return;
      }
      this.remarks_show = true;
      this.remarks_text = "";
      this.audit_status = 2;
    },

    //勾选变化
    table_selection_change(e) {
      console.log(e);
      this.table_selection = e;
    },

    click_count(title, index) {
      console.log("点击数量");
      this.drawer_title = title + "-详情";
      this.drawer_show = true;
      this.drawer_index = index;
      if (index == 0) {
        this.columns = [
          {
            type: "selection",
            width: 60,
            fixed: "left",
          },
          {
            title: "姓名",
            key: "name",
            width: 80,
            fixed: "left",
            resizable: true,
          },
          //   {
          //     title: "是否核销",
          //     slot: "is_hexiao",
          //     width: 100,
          //     fixed: "left",
          //     resizable: true,
          //   },

          {
            title: "收款人",
            key: "is_self",
            slot: 'is_self',
            width: 80,
          },
          {
            title: "证明材料",
            slot: "cailiao",
            width: 150,
            resizable: true,
          },

          {
            title: "发放主体",
            key: "project_subject_name",
            width: 160,
          },

          {
            title: "身份证号",
            key: "idcard",
            width: 180,
            resizable: true,
          },
          {
            title: "手机号",
            key: "phone",
            width: 120,
            resizable: true,
          },
          {
            title: "入职时间",
            key: "entry_time",
            width: 150,
            resizable: true,
          },
          {
            title: "借支金额",
            key: "money",
            width: 100,
            resizable: true,
          },
          {
            title: "开户行",
            key: "bank_of_deposit",
            width: 120,
            resizable: true,
          },
          {
            title: "受托人",
            key: "weituo_name",
            width: 100,
            resizable: true,
          },
          {
            title: "银行卡号",
            key: "bank_card_number",
            width: 180,
            resizable: true,
          },
          {
            title: "借支原因",
            key: "cause",
            width: 180,
            resizable: true,
          },
          {
            title: "提交时间",
            key: "create_time",
            width: 140,
            resizable: true,
          },

          {
            title: "删除",
            slot: "del",
            width: 60,
            resizable: true,
          },
        ];
      }
      if (index == 1) {
        this.columns = [
          {
            type: "index",
            width: 60,
            fixed: "left",
            resizable: true,
          },
          {
            title: "姓名",
            key: "name",
            width: 80,
            fixed: "left",
            resizable: true,
          },
          {
            title: "收款人",
            key: "is_self",
            slot: 'is_self',
            width: 80,
          },
          {
            title: "证明材料",
            slot: "cailiao",
            width: 150,
            resizable: true,
          },
          {
            title: "发放状态",
            slot: "is_fafang",
            width: 110,
          },
          {
            title: "是否核销",
            slot: "is_hexiao",
            width: 110,
            resizable: true,
          },
          {
            title: "发放主体",
            key: "project_subject_name",
            width: 160,
          },

          {
            title: "身份证号",
            key: "idcard",
            width: 180,
            resizable: true,
          },
          {
            title: "手机号",
            key: "phone",
            width: 120,
            resizable: true,
          },
          {
            title: "入职时间",
            key: "entry_time",
            width: 130,
            resizable: true,
          },
          {
            title: "借支金额",
            key: "money",
            width: 100,
            resizable: true,
          },
          {
            title: "受托人",
            key: "weituo_name",
            width: 100,
            resizable: true,
          },

          {
            title: "开户行",
            key: "bank_of_deposit",
            width: 120,
            resizable: true,
          },

          {
            title: "银行卡号",
            key: "bank_card_number",
            width: 180,
            resizable: true,
          },
          {
            title: "借支原因",
            key: "cause",
            width: 120,
            resizable: true,
          },

          {
            title: "审核备注",
            key: "audit_remarks",
            width: 120,
            resizable: true,
          },

          {
            title: "发放时间",
            key: "fafang_time",
            width: 120,
            resizable: true,
          },
          {
            title: "发放证明",
            slot: "fafang_receipt",
            width: 100,
            resizable: true,
          },
          {
            title: "发放备注",
            key: "fafang_remarks",
            width: 120,
            resizable: true,
          },
          {
            title: "核销日期",
            slot: "affirm_hexiao_time",
            width: 120,
            resizable: true,
          },
          {
            title: "提交时间",
            key: "create_time",
            width: 150,
            resizable: true,
          },
          //
        ];
      }
      if (index == 2) {
        this.columns = [
          {
            type: "index",
            width: 60,
            fixed: "left",
            resizable: true,
          },
          {
            title: "姓名",
            key: "name",
            width: 80,
            fixed: "left",
            resizable: true,
          },
          {
            title: "收款人",
            key: "is_self",
            slot: 'is_self',
            width: 80,
          },
          {
            title: "证明材料",
            slot: "cailiao",
            width: 150,
            resizable: true,
          },
          {
            title: "发放状态",
            slot: "is_fafang",
            width: 110,
          },
          {
            title: "是否核销",
            slot: "is_hexiao",
            width: 110,
            resizable: true,
          },

          {
            title: "发放主体",
            key: "project_subject_name",
            width: 160,
          },

          {
            title: "身份证号",
            key: "idcard",
            width: 180,
            resizable: true,
          },
          {
            title: "手机号",
            key: "phone",
            width: 120,
            resizable: true,
          },
          {
            title: "入职时间",
            key: "entry_time",
            width: 130,
            resizable: true,
          },
          {
            title: "借支金额",
            key: "money",
            width: 100,
            resizable: true,
          },
          {
            title: "受托人",
            key: "weituo_name",
            width: 100,
            resizable: true,
          },
          {
            title: "开户行",
            key: "bank_of_deposit",
            width: 120,
            resizable: true,
          },
          {
            title: "银行卡号",
            key: "bank_card_number",
            width: 180,
            resizable: true,
          },
          {
            title: "借支原因",
            key: "cause",
            width: 120,
            resizable: true,
          },

          {
            title: "审核备注",
            key: "audit_remarks",
            width: 120,
            resizable: true,
          },

          {
            title: "发放时间",
            key: "fafang_time",
            width: 120,
            resizable: true,
          },
          {
            title: "发放证明",
            slot: "fafang_receipt",
            width: 100,
            resizable: true,
          },
          {
            title: "发放备注",
            key: "fafang_remarks",
            width: 120,
            resizable: true,
          },
          {
            title: "预计核销",
            key: "hexiao_time",
            width: 120,
            resizable: true,
          },
          {
            title: "提交时间",
            key: "create_time",
            width: 150,
            resizable: true,
          },
        ];
      }

      this.get_jiezhi_data();
    },

    open(project_id, project_name) {
      this.project_id = project_id;
      this.project_name = project_name;

      this.get_jiezhi_data();
      this.get_jiezhi_setting_info();
      this.get_unwritten_count();
      this.$refs.relieve_data.open(this.project_id);
    },

    is_hexiao_change() {
      this.page = 1;
      this.get_jiezhi_data();
    },

    //获取借支数据
    get_jiezhi_data() {
      var that = this;

      var obj = {
        project_id: this.project_id,
        page: this.page,
        status: this.drawer_index,
        is_hexiao: this.is_hexiao,
        is_fafang: this.is_fafang,
        search_value: this.search_value,
        search_type: this.search_type,
      };
      this.table_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/jiezhi/jiezhi_data",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.daishen_count = res.data.daishen_count;
            that.butongguo_count = res.data.butongguo_count;
            that.tongguo_count = res.data.tongguo_count;
            that.audit_list = res.data.data_list;

            // that.audit_list = that.data_dict["audit_list"];
            // that.success_list = that.data_dict["success_list"];
            // that.fail_list = that.data_dict["fail_list"];
            that.total_count = res.data.total_count;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },

    //获取借支数据
    download_jiezhi_data() {
      var that = this;

      var obj = {
        project_id: this.project_id,
        status: this.drawer_index,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/jiezhi/jiezhi_data_export",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            var url = res.data.url;
            this.$Modal.confirm({
              title: '提示',
              content: '<p>导出完成，是否开始下载？</p>',
              onOk: () => {
                open_new_page(url);
              },
              onCancel: () => {
              }
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.download_loading=false
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_download() {
      this.download_loading=true
      this.download_jiezhi_data();

      // var that = this
      // this.$refs.table.exportCsv({
      //     filename: that.drawer_title
      // });
    },

    click_update_fafang_time(e) {
      this.fafang_time_show = true;
      this.fafang_time = e.fafang_time;
      this.fafang_jiezhi_id = e.jiezhi_id;
    },

    click_update_hexiao_time(e) {
      console.log(e);
      console.log(e.jiezhi_id);
      this.hexiao_time_show = true;
      this.hexiao_time = e.hexiao_time;
      this.hexiao_jiezhi_id = e.jiezhi_id;
      console.log(this.hexiao_jiezhi_id);
    },

    // 更新发放时间
    fafang_time_update_change(e) {
      if (e) {
        var timeStamp = Date.parse(e);
      } else {
        var timeStamp = 0;
      }

      var that = this;

      var obj = {
        id: this.fafang_jiezhi_id,
        time: timeStamp / 1000,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/jiezhi/fafang_time_update",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_jiezhi_data();
            that.fafang_time_show = false;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    // 更新核销时间
    hexiao_time_update_change(e) {
      if (e) {
        var timeStamp = Date.parse(e);
      } else {
        var timeStamp = 0;
      }

      var that = this;

      var obj = {
        id: this.hexiao_jiezhi_id,
        time: timeStamp / 1000,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/jiezhi/hexiao_time_update",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_jiezhi_data();
            that.hexiao_time_show = false;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    // 删除借支
    del_jiezhi(e) {
      var that = this;
      this.$Modal.confirm({
        title: "提示",
        content: "<p>确认删除吗</p>",
        onOk: () => {
          that.del_jiezhi_request(e);
        },
        onCancel: () => { },
      });
    },

    del_jiezhi_request(e) {
      var that = this;

      var obj = {
        id: e.jiezhi_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/jiezhi/del_jiezhi",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_jiezhi_data();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    focus_change() {
      this.update_jiezhi_setting_info();
    },

    sms_notify_change() {
      var that = this;

      var obj = {
        project_id: this.project_id,
        notify_status: this.setting_data.switch_sms_notify
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/jiezhi/switch_sms_notify_update",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.get_jiezhi_setting_info()
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    get_jiezhi_setting_info(e) {
      var that = this;

      var obj = {
        project_id: this.project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/jiezhi/jiezhi_limit_info",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.setting_data = res.data;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    update_jiezhi_setting_info(e) {
      var that = this;

      var obj = {
        project_id: this.project_id,
        money: this.setting_data.money,
        after_verification: this.setting_data.after_verification,
        month_count: this.setting_data.month_count
      };
      http(
        "post",
        process.env.VUE_APP_HOST +
        "/my_project/project_detail/jiezhi/jiezhi_limit_update",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_jiezhi_setting_info();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
  },
};
</script>

<style scoped>
.jiezhi_count_tishi2 {
  font-size: 13px;
  color: #333333;
  padding: 5px;
  background-color: #ffe0e0;
  margin-bottom: 10px;
}
.jiezhi_count_tishi {
  font-size: 13px;
  color: #333333;
  padding: 5px;
  background-color: #f5f5d5;
  margin-bottom: 10px;
}

.tishi {
  font-size: 13px;
  background-color: #ff251d;
  color: white;
  padding: 3px 5px;
  margin-bottom: 5px;
  border-radius: 5px;
}

.upload_hexiao {
  display: flex;
  align-items: center;
}

.affirm_hexiao_btn {
  display: flex;
  justify-content: flex-end;
}

.jiezhi_peizhi_title {
  width: 170px;
  flex-shrink: 0;
}

.jiezhi_peizhi_div {
  padding: 10px 15px;
}

.jiezhi_peizhi_div2 {
  padding: 10px 15px;
}

.confirm_div {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.setting_input {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.setting_input_title {
  width: 170px;
  flex-shrink: 0;
}

.icon2 {
  font-size: 18px;
}

.left_btn {
  display: flex;
  align-items: center;
}

.is_hexiao_div {
  display: flex;
  align-items: center;
}

.page_1 {
  padding-top: 3px;
  display: flex;
  justify-content: center;
}

.del_jiezhi {
  color: #f10800;
  cursor: pointer;
}

.fafang_time {
  cursor: pointer;
  color: #425dc0;
}

.search_box {
  padding-bottom: 10px;
}

.audit_box2_title {
  margin-bottom: 10px;
}

.audit_box {
  margin: 10px 0;
  display: flex;
  align-items: center;
}

.download_box_ts {
  background: #f82323;
  color: #fff;
  padding: 1px 10px;
  font-size: 13px;
  border-radius: 3px;
}

.download_box_right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.download_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
}

.table_card_scroll {
  height: calc(100vh - 90px);
  overflow: auto;
  position: relative;
}

.jiezhi_box {
  border-top: 1px dashed #ccc;
  margin: 10px 0 10px 0;
  padding-top: 10px;
}

.create_time {
  font-size: 12px;
  text-align: right;
}

.name {
  font-size: 13px;
  font-weight: 600;
  color: #000;
}

.card_inner {
  font-size: 13px;
  color: #333;
  display: flex;
  align-items: center;
}

.table_card {
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
}

.title_text2 {
  font-weight: 600;
}

.export_table {
  font-size: 12px;
  color: #0466dd;
  font-weight: 300;
  margin-right: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  letter-spacing: 1px;
}

.title_text {
  margin: 0px 10px 0 10px;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #ddd;
  padding: 10px 10px 5px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  letter-spacing: 2px;
}

.card_main {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  position: relative;
}

.count_title {
  font-size: 13px;
  color: #333;
  margin-top: 5px;
}

.count_title2 {
  font-size: 13px;
  /* margin-top: 5px; */
}

.fafang_receipt {
  color: #0466dd;
}


.count_card2 {
  margin: 0 10px 10px 0;
  cursor: pointer;
  height: 65px;
  padding: 10px 10px 5px 10px;
  width: 110px;
  border-radius: 5px;
  color: #fff;
  background-color: #0466dd;
  text-align: center;
  border: 1px solid #b8bef7;
}


.count_card {
  margin: 0 10px 10px 0;
  cursor: pointer;
  height: 65px;
  padding: 10px 10px 5px 10px;
  width: 110px;
  border-radius: 5px;

  background-color: #fff;
  text-align: center;
  border: 1px solid #b8bef7;
}

.count_card:hover {
  background-color: #0466dd;
  color: #fff;
}

.data_div {
  padding: 10px;
  border-radius: 5px;
}

.query_box {
  display: flex;
  justify-content: flex-end;
}
</style>
